import { useQuery } from "@tanstack/react-query";
import { useAuthenticatedAPI } from "@/api";

export function useGetBusinesses() {
  const api = useAuthenticatedAPI();

  return useQuery({
    queryKey: ["businesses"],
    queryFn: async () => {
      const resp = await api.getBusinesses();
      return resp.data;
    },
    enabled: Boolean(api),
    staleTime: Infinity,
  });
}
